document.addEventListener('DOMContentLoaded', function () {
    // Sabhi text links select karo jinke sath submenu hai
    var menuLinks = document.querySelectorAll('.wbmenul1_link');

    menuLinks.forEach(function (link) {
        link.addEventListener('click', function (e) {
            // Agar yeh link ke sath submenu hai tabhi prevent karo
            if (this.nextElementSibling || this.querySelector('svg.wbmegamainhd')) {
                e.preventDefault();

                // Arrow ke click ke liye jo function/theme use karti hai usko trigger karo
                this.querySelector('svg.wbmegamainhd')?.dispatchEvent(new Event('click', { bubbles: true }));
            }
        });
    });
});
